import { formatRupiah } from "@/lib/format";

// Shared RFQ config — dipakai panel karyawan & admin agar konsisten.
export const RFQ_STATUS = {
  submitted: {
    label: "Submitted",
    className: "border-[hsl(var(--warning))] text-[hsl(var(--warning))]",
  },
  completed: {
    label: "Completed",
    className: "border-[hsl(var(--success))] text-[hsl(var(--success))]",
  },
};

export const RFQ_NEXT_STATUS = {
  submitted: "completed",
  completed: null,
};

export const RFQ_UOM_OPTIONS = [
  "PCS", "BOX", "UNIT", "KG", "SET", "PAK", "BTL", "METER", "LITER", "RIM", "LOT",
];

export const RFQ_DEPT_SUGGESTIONS = [
  "Operasional", "Keuangan", "HRD", "Marketing", "IT", "Logistik", "Produksi",
];

export const RFQ_HISTORY_LABEL = {
  created: "RFQ dibuat",
  status_changed: "Perubahan status",
  quotation_uploaded: "Quotation diupload",
  note: "Catatan admin",
};

export function rfqStatusMeta(status) {
  return RFQ_STATUS[status] || { label: status, className: "" };
}

export function calcGrandTotal(items) {
  return (items || []).reduce(
    (s, v) => s + Number(v.qty || 0) * Number(v.price || 0),
    0
  );
}

export function formatRfqMoney(v) {
  return formatRupiah(v);
}

export const RFQ_DAYS = ["Minggu", "Senin", "Selasa", "Rabu", "Kamis", "Jumat", "Sabtu"];
export const RFQ_MONTHS = [
  "Januari", "Februari", "Maret", "April", "Mei", "Juni",
  "Juli", "Agustus", "September", "Oktober", "November", "Desember",
];

// Date -> "11/09/2026" (format yang sama dengan request_date backend)
export function toIDDate(d) {
  const p = (n) => String(n).padStart(2, "0");
  return `${p(d.getDate())}/${p(d.getMonth() + 1)}/${d.getFullYear()}`;
}

// Date -> "Kamis, 11 September 2026"
export function formatHariTanggal(d) {
  return `${RFQ_DAYS[d.getDay()]}, ${d.getDate()} ${RFQ_MONTHS[d.getMonth()]} ${d.getFullYear()}`;
}

export function addDays(d, n) {
  const c = new Date(d);
  c.setDate(c.getDate() + n);
  return c;
}

export function isToday(d) {
  return toIDDate(d) === toIDDate(new Date());
}

// "2026-09-11T10:42:00..." -> "11/09/2026 10:42" ; "11/09/2026" dilewatkan apa adanya
export function fmtDateTime(iso) {
  if (!iso) return "—";
  const s = String(iso);
  if (/^\d{2}\/\d{2}\/\d{4}$/.test(s)) return s;
  const d = new Date(s);
  if (isNaN(d.getTime())) return s;
  const p = (n) => String(n).padStart(2, "0");
  return `${p(d.getDate())}/${p(d.getMonth() + 1)}/${d.getFullYear()} ${p(d.getHours())}:${p(d.getMinutes())}`;
}
